<template>
    <div class="dialogMainContainer">
        <!-- !!!!!!!! Used to test the dialogGroups !!!!!! -->
        <!--<div class="testContainer">
            <select v-model="selected">
                <option v-for="dg in dialogGroups" v-bind:value="dg.key">
                    {{ dg.key }}
                </option>
            </select>
            <span style="cursor:pointer; margin-left:10px; padding:5px; background-color:darkgray;" @click="testGroup(selected)" type="button">Test Group</span>
        </div>-->
        <div id="closeBtnDiv">
            <div id="closeBtn" @click="closeAva"></div>
        </div>
        <div class="mainContentDiv">
            <div class="questionContainer">
                <input type="text" name="askAvaQuestion" v-model="askAvaQuestion" v-on:keyup="listenForEnter" />
                <!--<input type="text" name="searchText" v-model="searchText" v-on:keyup="listenForEnter" v-bind:disabled="waitingForAnswer" />-->
                <button @click="askAva()" type="button">Ask Ava</button>
            </div>
            <div class="answerContainer" id="dialogDiv">
                <div v-for="comment in comments">
                    <div class="chatRowAva" v-if="comment.isAva">
                        <div class="avaIcon"><img src="../assets/images/chat_avatar_ava.png" /><br />AVA</div>
                        <div class="bubbleAva ava">
                            <!--BASIC TEXT CARD-->
                            <div v-if="comment.type === 'basic'">
                                <p>{{comment.text}}</p>
                                <div class="headerDiv" v-if="comment.title">
                                    <h4>{{comment.title}}</h4>
                                </div>
                                <div class="textDiv">
                                    {{comment.answer}}
                                </div>
                                
                                <div class="buttonDiv">
                                    <div v-for="button in comment.buttons">
                                        <div v-if="button.type === 'openUrl'">
                                            <a @click="navigateTo(button.value)" class="btn">{{button.title}}</a>
                                        </div>
                                        <div v-if="button.type === 'callParent'">
                                            <a @click="callParent(button.value)" class="btn">{{button.title}}</a>
                                        </div>
                                    </div>
                                </div>
                                <div class="bubbleAvaIconsContainer">
                                    <!--<img src="../assets/images/icon_mail.png" />-->
                                    <!--<img src="../assets/images/icon_print.png" />-->
                                </div>
                            </div>
                            <!--HERO CARD-->
                            <div v-else-if="comment.type === 'hero'">
                                <p>{{comment.text}}</p>

                                <div class="headerDiv">
                                    <h4>{{comment.content.title}}</h4>
                                    <span>{{comment.content.subtitle}}</span>
                                </div>
                                <div class="imgDiv">
                                    <img v-bind:src="comment.content.images[0].url" />
                                </div>

                                <div class="textDiv">
                                    {{comment.content.text}}
                                </div>
                                <div class="buttonDiv">
                                    <div v-for="button in comment.content.buttons">
                                        <div v-if="button.type === 'openUrl'">
                                            <a @click="navigateTo(button.value)" class="btn">{{button.title}}</a>
                                        </div>
                                    </div>
                                </div>
                                <div class="bubbleAvaIconsContainer">
                                    <!--<img src="../assets/images/icon_mail.png" />-->
                                    <!--<img src="../assets/images/icon_print.png" />-->
                                </div>
                            </div>
                            <!--THUMBNAIL CARD-->
                            <div v-else-if="comment.type === 'thumbnail'">
                                <p>{{comment.text}}</p>
                                <div class="headerDiv">
                                    <h4>{{comment.content.title}}</h4>
                                    <span>{{comment.content.subtitle}}</span>
                                </div>

                                <div class="imgDiv">
                                    <img v-bind:src="comment.content.images[0].url" />
                                </div>
                                <div class="textDiv">
                                    {{comment.content.text}}
                                </div>
                                <div class="buttonDiv">
                                    <div v-for="button in comment.content.buttons">
                                        <div v-if="button.type === 'openUrl'">
                                            <a @click="navigateTo(button.value)" class="btn">{{button.title}}</a>
                                        </div>
                                    </div>
                                </div>
                                <div class="bubbleAvaIconsContainer">
                                    <!--<img src="../assets/images/icon_mail.png" />-->
                                    <!--<img src="../assets/images/icon_print.png" />-->
                                </div>
                            </div>
                            <!--VIDEO CARD-->
                            <div v-else-if="comment.type === 'video'">
                                <p>{{comment.text}}</p>

                                <div class="headerDiv">
                                    <h4>{{comment.content.title}}</h4>
                                    <span>{{comment.content.subtitle}}</span>
                                </div>
                                <div class="videoCard_video">
                                    <video v-bind:src="comment.content.media[0].url" controls style="width:100%;">
                                        Your browser does not support the video tag.
                                    </video>
                                </div>
                                <div class="textDiv">
                                    {{comment.content.text}}
                                </div>

                                <div class="buttonDiv">
                                    <div v-for="button in comment.content.buttons">
                                        <div v-if="button.type === 'openUrl'">
                                            <a @click="navigateTo(button.value)" class="btn">{{button.title}}</a>
                                        </div>
                                    </div>
                                </div>
                                <div class="bubbleAvaIconsContainer">
                                    <!--<img src="../assets/images/icon_mail.png" />-->
                                    <!--<img src="../assets/images/icon_print.png" />-->
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="chatRow" v-else>
                        <div class="youIcon"><img class="avatarImg" v-bind:src="avatarUrl" /><br />{{user.name}}</div>
                        <div class="bubble me"><p>{{comment.text}}</p></div>
                    </div>
                </div>
            </div>

        </div>


    </div>
</template>
<script>
    import Vue from 'vue';
    import { mapState, mapActions, mapGetters } from 'vuex'
    import dialogGroups from '../store/dialogGroups';

    export default {
        namespaced: true,
        name: 'Dialog',
        data() {
            return {
                selected: '',
                dialogGroups: dialogGroups.getAllDialogGroups()
            }    
        },
        computed: {
            ...mapState({
                user: state => state.user
            }),
            ...mapGetters('dialog', {
                comments: 'comments'
            }),
            avatarUrl() {
                const avatar = (this.user && this.user.avatar) || '';
                const token = (this.user && this.user.token) || '';
                return `${avatar}`;
            },            
            askAvaQuestion: {
                get() {
                    return this.$store.state.askAvaQuestion;
                },
                set(value) {
                    this.$store.commit('updateAskAvaQuestion', value);
                }
            }
        },
        methods: {
            ...mapActions({
                askAva: 'dialog/askAva',
                navigateTo: 'dialog/navigateTo',
                callParent: 'dialog/callParent',
                closeAva: 'closeAva'
            }),
            listenForEnter: function (e) {
                if (e.keyCode === 13) {
                    this.$store.dispatch('dialog/askAva');
                } else {
                    // reset timer once a user starts typing a question
                    this.$store.dispatch('setIdleTimeOutTimer');
                }
            },
            scrollToEnd() {
                var container = this.$el.querySelector(".dialogDiv");
                container.scrollTop = container.scrollHeight;
            },
            testGroup(key) {
                this.$store.dispatch('selectGroupByKey', key);
            }
        },
        watch: {
            'comments': function (val, oldVal) {
                let vm = this;
                let scorllTimeOut = setTimeout(function () {
                    var container = vm.$el.querySelector("#dialogDiv");
                    container.scrollTop = container.scrollHeight;
                }, 300);
            },
            'selected': function (val, oldVal) {
                this.$store.dispatch('selectGroupByKey', val);
            }
        }
    }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

    h3 {
        margin: 40px 0 0;
    }

    ul {
        list-style-type: none;
        padding: 0;
    }

    li {
        display: inline-block;
        margin: 0 10px;
    }

    a {
        color: #42b983;
    }

    .dialogMainContainer {
        float: left;
        width: 660px;
        height: 540px;
    }

    .questionContainer {
        width: calc(100% - 30px);
        height: 66px;
        position: RELATIVE;
        TOP: 30px;
    }

    .answerContainer {
        width: calc(100% - 30px);
        height: 408px;
        /* margin-left: 2px; */
        background-color: rgba(255, 255, 255, 0.5);
        border: 1px solid #9EA9BB;
        border-radius: 4px;
        -webkit-box-shadow: 6px 6px 14px 2px rgba(0, 0, 0, 0.32);
        box-shadow: 6px 6px 14px 2px rgba(0, 0, 0, 0.32);
        padding: 20px;
        overflow: auto;
        position: relative;
        top: 13px;
    }

    input {
        background-color: rgba(255, 255, 255, 0.5);
        height: 32px;
        width: 88%;
        margin: auto;
        padding-left: 5px;
        display: block;
        -webkit-box-flex: 1;
        flex: 1;
        border: 1px solid #9EA9BB;
        border-radius: 4px;
        transition: .4s cubic-bezier(.25,.8,.25,1);
        transition-property: font-size,padding-top,color;
        font-family: inherit;
        font-size: 16px;
        line-height: 32px;
        -webkit-box-shadow: 6px 6px 14px 2px rgba(0, 0, 0, 0.32);
        -moz-box-shadow: 6px 6px 14px 2px rgba(0, 0, 0, 0.32);
        box-shadow: 6px 6px 14px 2px rgba(0, 0, 0, 0.32);
        padding-right: 105px;
    }

        input:focus {
            border-color: #D2C9C3 !important;
        }

    button {
        width: 100px;
        height: 35px;
        margin: 0;
        position: absolute;
        top: 1px;
        right: -42px;
        -webkit-transition: .4s cubic-bezier(.4,0,.2,1);
        transition: .4s cubic-bezier(.4,0,.2,1);
        border-radius: 6%;
        z-index: 6;
        font-weight: 500;
        text-transform: uppercase;
        padding: 0;
        display: inline-block;
        overflow: hidden;
        outline: none;
        background: transparent;
        border-left: 1px solid #9EA9BB;
        border-top: none;
        border-right: none;
        border-bottom: none;
        font-family: inherit;
        line-height: normal;
        text-decoration: none;
        vertical-align: top;
        white-space: nowrap;
        cursor: pointer;
    }

        button:hover {
            background-color: #788395;
            color: white;
        }

    .chatRow {
        display: inline-block;
        margin-top: 10px;
        width: 100%;
    }

    .chatRowAva {
        text-align: right;
        position: relative;
        min-height: 70px;
        display: inline-block;
        margin-top: 10px;
        width: 100%;
    }


    .avatarImg {
        border-radius: 50%;
        border: 3px solid #9EA9BB;
        width: 67px;
        height: 67px;
    }

    .youIcon {
        height: 70px;
        width: 100px;
        float: left;
        text-align: center;
        font-weight: bold;
    }


    .bubble {
        background-color: #fff;
        border: 2px solid #9EA9BB;
        border-radius: 50px;
        -webkit-box-shadow: 4px 4px 16px #B2B2B2;
        box-shadow: 4px 4px 16px #B2B2B2;
        display: inline-block;
        padding: 10px 24px;
        position: relative;
        vertical-align: top;
        max-width: 356px;
        text-align: left;
    }

        .bubble::before {
            border-left: 2px solid #9EA9BB;
            border-bottom: 2px solid #9EA9BB;
            background-color: #fff;
            content: "\A0";
            display: block;
            height: 21px;
            position: absolute;
            top: 4px;
            -webkit-transform: rotate( 43deg ) skew( -35deg );
            transform: rotate( 43deg ) skew( -35deg );
            -moz-transform: rotate( 43deg ) skew( -35deg );
            -ms-transform: rotate( 43deg ) skew( -35deg );
            -o-transform: rotate( 43deg ) skew( -35deg );
            /* -webkit-transform: rotate( 29deg ) skew( -35deg ); */
            width: 30px;
            /* border: 1px solid red; */
            border-top-left-radius: 111px;
            border-bottom-left-radius: 59px;
            border-bottom-right-radius: 51px;
        }

    .me {
        float: left;
        margin: 5px 25px 5px 25px;
    }

        .me::before {
            /*box-shadow: -2px 2px 2px 0 rgba( 178, 178, 178, .4 );*/
            left: -11px;
        }

        .me p {
            max-width: 100%;
            overflow: hidden;
        }

    .avaIcon {
        position: absolute;
        bottom: 0px;
        right: 0px;
        text-align:center;
        font-weight:bold;
    }

    .bubbleAva {
        position: relative;
        top: 1px;
        right: 75px;
        background-color: #E6E1DD;
        border: 2px solid #9EA9BB;
        border-radius: 20px;
        -webkit-box-shadow: 4px 4px 10px #B2B2B2;
        box-shadow: 4px 4px 10px #B2B2B2;
        display: inline-block;
        padding: 10px 24px;
        vertical-align: top;
        max-width: 398px;
        text-align: left;
    }

        .bubbleAva::before {
            border-left: 2px solid #9EA9BB;
            border-bottom: 2px solid #9EA9BB;
            background-color: #E6E1DD;
            content: "\A0";
            display: block;
            height: 21px;
            position: absolute;
            bottom: 0px;
            -webkit-transform: rotate( 220deg ) skew( -35deg );
            transform: rotate( 220deg ) skew( -35deg );
            -moz-transform: rotate( 220deg ) skew( -35deg );
            -ms-transform: rotate( 220deg ) skew( -35deg );
            -o-transform: rotate( 220deg ) skew( -35deg );
            /* -webkit-transform: rotate( 29deg ) skew( -35deg ); */
            width: 30px;
            /* border: 1px solid red; */
            border-top-left-radius: 111px;
            border-bottom-left-radius: 59px;
            border-bottom-right-radius: 51px;
            box-shadow: -9px 1px 10px #B2B2B2;
            -webkit-box-shadow: -9px 1px 10px #B2B2B2;
        }

    .ava {
        float: right;
        margin: 5px 20px 5px 45px;
    }

        .ava::before {
            /*box-shadow: 2px -2px 2px 0 rgba( 178, 178, 178, .4 );*/
            right: -16px;
        }

    .youChatBubble {
        position: relative;
        width: 400px;
        left: 150px;
        padding: 50px 15px;
        margin: 1em 0 3em;
        border: 10px solid #5a8f00;
        text-align: center;
        color: #333;
        background: #fff;
        -webkit-border-radius: 20px;
        -moz-border-radius: 20px;
        border-radius: 20px;
    }

        .youChatBubble:before {
            content: "";
            position: absolute;
            z-index: 10;
            bottom: -40px;
            left: 50px;
            width: 50px;
            height: 30px;
            border-style: solid;
            border-width: 0 10px 10px 0;
            border-color: #5a8f00;
            background: transparent;
            -webkit-border-bottom-right-radius: 80px 50px;
            -moz-border-radius-bottomright: 80px 50px;
            border-bottom-right-radius: 80px 50px;
            display: block;
        }

        .youChatBubble:after {
            content: "";
            position: absolute;
            z-index: 10;
            bottom: -40px;
            left: 50px;
            width: 20px;
            height: 30px;
            border-style: solid;
            border-width: 0 10px 10px 0;
            border-color: #5a8f00;
            background: transparent;
            -webkit-border-bottom-right-radius: 40px 50px;
            -moz-border-radius-bottomright: 40px 50px;
            border-bottom-right-radius: 40px 50px;
            display: block;
        }

        .youChatBubble > :first-child:before {
            content: "";
            position: absolute;
            bottom: -40px;
            left: 45px;
            width: 10px;
            height: 10px;
            background: #5a8f00;
            -webkit-border-radius: 10px;
            -moz-border-radius: 10px;
            border-radius: 10px;
        }

        .youChatBubble > :first-child:after {
            content: "";
            position: absolute;
            bottom: -10px;
            left: 76px;
            width: 24px;
            height: 15px;
            background: #fff;
        }

    .bubbleAvaIconsContainer {
    }

        .bubbleAvaIconsContainer img {
            float: right;
            padding-right: 10px;
            cursor: pointer;
        }

    .imgDiv img {
        width: 100%;
    }

    .textDiv {
        margin: 10px 0;
    }

    .buttonDiv {
        margin-top: 20px;
    }

    .btn {
        display: inline-block;
        font-weight: 400;
        text-align: center;
        white-space: nowrap;
        vertical-align: middle;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        border: 1px solid transparent;
        padding: .375rem .75rem;
        font-size: 1rem;
        line-height: 1.5;
        border-radius: .25rem;
        transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
        color: #fff;
        background-color: #007bff;
        border-color: #007bff;
        text-decoration: none;
        cursor:pointer;
    }

    #allowSpeechBtn {
        width: 394px;
        height: 74px;
        margin: 200px auto;
        background-image: url(~/ava/avaspeakbutton-regular.png);
    }

        #allowSpeechBtn:hover {
            opacity: 0.5;
        }

    #closeBtnDiv {
        position: relative;
    }

    #closeBtn {
        position: absolute;
        right: 0px;
        width: 31px;
        height: 31px;
        background-image: url(~/ava/ava_x_reg.png);
        cursor:pointer;
    }

        #closeBtn:hover {
            background-image: url(~/ava/ava_x_hover.png);
        }

    .mainContentDiv {
        width: 610px;
    }
    .headerDiv {
        border-top: 1px solid silver;
    }
    .videoCard_video {
        margin-top: 10px;
    }
    .imgDiv {
        margin-top: 10px;
    }
</style>
